import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator, faChartBar } from "@fortawesome/free-solid-svg-icons";
import { Loading } from "../../../../components/common";
import AssessmentItem from "../AssessmentItem/AssessmentItem";
import { useTranslation } from "../../../../hooks";
import styles from "./AssessmentsList.module.css";

const AssessmentsList = ({
	assessmentsLoading,
	currentMonthAssessments,
	totalMonthPoints,
	selectedMonth,
	onAssessmentClick,
	onDeleteAssessment,
}) => {
	const { t } = useTranslation();

	if (assessmentsLoading) {
		return (
			<div className={styles.assessmentEmpty}>
				<Loading
					message={
						t("assessment.loadingAssessments") || "Loading assessments..."
					}
				/>
			</div>
		);
	}

	if (currentMonthAssessments.length === 0) {
		return (
			<div className={styles.assessmentEmpty}>
				{(
					t("assessment.noAssessmentsForMonth") ||
					"No assessments found for {month}"
				).replace("{month}", selectedMonth)}
			</div>
		);
	}

	return (
		<>
			<div className={styles.monthSummary}>
				<div className={styles.monthTotal}>
					<FontAwesomeIcon icon={faCalculator} />
					{totalMonthPoints} {t("assessment.pointsTotal") || "Points Total"}
				</div>
				<div className={styles.monthCount}>
					<FontAwesomeIcon icon={faChartBar} />
					{currentMonthAssessments.length}{" "}
					{t("assessment.assessments") || "Assessments"}
				</div>
			</div>

			<div className={styles.assessmentGrid}>
				{currentMonthAssessments.map((assessment) => (
					<AssessmentItem
						key={assessment.id}
						assessment={assessment}
						onClick={onAssessmentClick}
						onDelete={onDeleteAssessment}
					/>
				))}
			</div>
		</>
	);
};

export default AssessmentsList;
